<template>
  <div class="barcode-scanner-hello-world-page">
    <div
      v-if="vShow && vShow.active && allowed"
      class="input-group">
      <button
        class="btn btn-primary w-50"
        :class="{active: standardSearch}"
        @click="setStandard">
        <i
          v-if="standardSearch"
          class="fa fa-check-circle"/>
        Standard Search
      </button>
      <button
        class="btn btn-primary w-50"
        :class="{active: vShowSearch}"
        @click="setVshow">
        <i
          v-if="vShowSearch"
          class="fa fa-check-circle"/>
        {{vShow.title}} Search
      </button>
    </div>
    <!-- This div will host the barcode scanner's camera view -->
    <div class="barcode-scanner-view" ref="scannerViewRef"></div>
  </div>
</template>

<script setup>
  import { BarcodeScanner } from '../dist/dbr.bundle';
  import { search } from './search'
  import { onMounted, onUnmounted, ref, computed } from 'vue'
  import { useStore } from 'vuex'

  const standardSearch = ref(true)
  const vShowSearch = ref(false)
  const store = useStore()
  const scannerViewRef = ref(null);
  let barcodeScanner

  onMounted(() => {
    // Configuration object for initializing the BarcodeScanner instance
    const config = {
      license: "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxNTMyMjE2LVRYbFhaV0pRY205cVgyUmljZyIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTUzMjIxNiIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOi0xNDQ0Mzg4Nzl9", // Replace with your Dynamsoft license key
      container: scannerViewRef.value, // Specify where to render the scanner UI
      showUploadImageButton: true,
      // Specify the path for the definition file "barcode-scanner.ui.xml" for the scanner view.
      uiPath: "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@11.0.6000/dist/",

      scannerViewConfig: {
        showFlashButton: true,
        cameraSwitchControl: "toggleFrontBack",
        showCloseButton: false,
      },

      // Specify custom paths for the engine resources
      engineResourcePaths: {
        rootDirectory: "https://cdn.jsdelivr.net/npm/",
      },
    }
  
    // Create an instance of the BarcodeScanner with the provided configuration
    barcodeScanner = new BarcodeScanner(config);

    // Launch the scanner; once a barcode is detected, display its text in an alert
    barcodeScanner.launch().then((result) => {
      if(result.barcodeResults.length) {
        search(result.barcodeResults[0], mode.value)
        barcodeScanner.dispose()
      }
    });
  })

  onUnmounted(()=>{
    barcodeScanner.dispose()
  })

  // Computed
  const vShow = computed(()=>{
    return store.getters.vShowDates
  })

  const mode = computed(()=>{
    if(vShowSearch.value) return 'vShow'
    return 'standard'
  })

  const company = computed(()=>{
    return store.getters.sessionCompany
  })

  // EJW / Cheney business does not run vShows currently
  const allowed = computed(()=>{
    return ['Lancaster Canada', 'Lancaster US'].includes(company.value)
  })

  // Methods
  const setVshow = ()=>{
    vShowSearch.value = true
    standardSearch.value = false
  }
  const setStandard = ()=>{
    standardSearch.value = true
    vShowSearch.value = false
  }
</script>

<style scoped>
.barcode-scanner-hello-world-page {
  width: 100%;
  height: 100%;
  text-align: center;
}

.barcode-scanner-title {
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

.barcode-scanner-title .barcode-scanner-title-logo {
  width: 30px;
  height: 30px;
  margin-left: 10px;
}

.barcode-scanner-view {
  width: 100%;
  height: calc(100% - 90px);
}
</style>
